import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { setAssignDriver } from "../../../redux/reducer/transport.reducer";

import ContentCard from "../../../components/misc/ContentCard";
import Text from "../../../styleguide/Text";

import AssignDriverIntranod from "./AssignDriverIntranod";
import AssignDriverRoute from "./AssignDriverRoute";
import AssignDriverComposed from "./AssignDriverComposed";

const types = ["local", "internod", "compusa"] as const;

function AssignDriver() {
  const dispatch = useAppDispatch();
  const [routeType, setRouteType] = useState<"local" | "internod" | "compusa">(
    "local",
  );

  const {
    transport: { assignedDriverData },
  } = useAppSelector((state) => ({
    transport: state.transport,
  }));

  useEffect(() => {
    if (assignedDriverData) {
      let routeTypeConst: "local" | "internod" | "compusa" = "local";
      if (assignedDriverData.id_ruta_intranod && assignedDriverData.id_ruta) {
        routeTypeConst = "compusa";
      } else if (assignedDriverData.id_ruta_intranod) {
        routeTypeConst = "internod";
      }
      setRouteType(routeTypeConst);
    }
  }, [assignedDriverData]);

  useEffect(() => {
    return () => {
      dispatch(setAssignDriver(null));
    };
  }, [dispatch]);

  return (
    <ContentCard
      CardHeader={() => (
        <div className="flex w-full flex-wrap items-center justify-between gap-4">
          <Text variant="h1" className="!m-0">
            Asignare ruta
          </Text>
          {!assignedDriverData && (
            <fieldset className="flex flex-wrap items-center gap-2 border-0 p-0">
              <legend className="sr-only">Tipul rutei</legend>
              {types.map((type) => (
                <label
                  key={type}
                  className={`inline-flex h-10 cursor-pointer items-center gap-2 rounded-control border px-3 text-sm font-semibold transition-colors ${
                    routeType === type
                      ? "border-[#2196f3] bg-[#eaf5fe] text-[#1976d2]"
                      : "border-slate-200 bg-white text-slate-700 hover:border-slate-300 hover:bg-surface-hover"
                  }`}>
                  <input
                    className="h-4 w-4 shrink-0 cursor-pointer accent-[#2196f3]"
                    type="radio"
                    name="routeType"
                    value={type}
                    checked={routeType === type}
                    onChange={() => setRouteType(type)}
                  />
                  <span>{type.charAt(0).toUpperCase() + type.slice(1)}</span>
                </label>
              ))}
            </fieldset>
          )}
        </div>
      )}>
      {routeType === "local" && <AssignDriverRoute />}
      {routeType === "internod" && <AssignDriverIntranod />}
      {routeType === "compusa" && <AssignDriverComposed />}
    </ContentCard>
  );
}

export default AssignDriver;
